module.exports = __webpack_public_path__ + "img/consent_renew.96b3cd62.svg";